import { keyframes, styled } from "@mui/material";

const vibrarAnimation = keyframes`
  0% {
    transform: rotate(-15deg);
  }
  50% {
    transform: rotate(15deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

export const StyledVibratingIcon = {
  Icon: styled("span")(({ theme, vibrar }) => ({
    transition: "transform 0.2s ease-in-out",
    animation: vibrar ? `${vibrarAnimation} 0.5s ease-in-out` : "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    "& svg": {
      transition: "inherit",
    }
  })),
}